module.exports = __webpack_public_path__ + "static/media/step-4-en.e2372f14.jpg";